import React from 'react';

import PDFViewer from '@/components/FileViewers/PDFViewer/PDFViewer';
import AudioPlayer from '@/components/FileViewers/Player/AudioPlayer';
import VideoPlayer from '@/components/FileViewers/Player/VideoPlayer';
import TextFileViewer from '@/components/FileViewers/TextFileViewer/TextFileViewer';
import { IFilePreviewProps } from 'interfaces/PreviewScreen/previewScreen';

import ThreeDViewer from '../FileViewers/3dViewer/ThreeDViewer';
import CSVViewer from '../FileViewers/CSVViewer/CSVViewer';
import DefaultFilePreview from '../FileViewers/DefaultFilePreview/DefaultFilePreview';
import XLSXViewer from '../FileViewers/XLSXViewer/XLSXViewer';

const FilePreview = ({
  setIsEditClicked,
  isEditClicked,
  fileResponse,
  setIsLexical,
}: IFilePreviewProps) => {
  const mimetype = fileResponse?.data.mimetype?.substring(0, 5);
  function renderComponent() {
    if (
      fileResponse.data.mimetype === 'application/octet-stream' &&
      (fileResponse.data.name.includes('.glb') ||
        fileResponse.data.name.includes('.gltf') ||
        ['gltf', 'glb'].includes(fileResponse.data?.extension))
    ) {
      return <ThreeDViewer url={fileResponse.data.url} />;
    }
    if (fileResponse.data.mimetype === 'application/pdf')
      return (
        <div
          className="h-[500px] overflow-auto no-scrollbar flex flex-col justify-center 
    items-center lg:h-full w-full bg-[#525659]"
        >
          <PDFViewer url={fileResponse.data.url} />
        </div>
      );

    if (
      fileResponse.data.mimetype === 'application/json' ||
      fileResponse.data?.extension === 'md'
    )
      return (
        <div className="w-full h-full overflow-y-auto">
          <TextFileViewer
            fileData={fileResponse.data}
            isEditClicked={isEditClicked}
            setIsEditClicked={setIsEditClicked}
            setIsLexical={setIsLexical}
          />
        </div>
      );

    if (fileResponse.data.mimetype === 'text/csv')
      return (
        <div className="w-full h-full overflow-hidden border">
          <CSVViewer url={fileResponse.data.url} />
        </div>
      );

    if (fileResponse.data?.extension === 'xlsx')
      return <XLSXViewer fileResponse={fileResponse} />;

    if (mimetype === 'audio')
      return (
        <div className="w-full h-full">
          <AudioPlayer
            url={fileResponse.data.url}
            mimetype={fileResponse.data.mimetype}
          />
        </div>
      );

    if (mimetype === 'image')
      return (
        <div className="w-full  h-full p-4 flex justify-center items-center">
          <img
            src={fileResponse.data.url} // quick fix add a 404 image
            alt={fileResponse.data.name}
            className="rounded-[6px] max-h-full"
          />
        </div>
      );

    if (mimetype === 'video')
      return (
        <div className="w-full h-full p-4 flex justify-center items-center">
          <VideoPlayer
            url={fileResponse.data.url}
            mimetype={fileResponse.data.mimetype}
          />
        </div>
      );

    return <DefaultFilePreview fileResponse={fileResponse} />;
  }

  return (
    <section className="h-[76vh] relative w-full bg-white rounded-[8px] box-border">
      {renderComponent()}
    </section>
  );
};

export default FilePreview;
